"use client"

import { IconButton, Tooltip, Box } from "@mui/material"
import type { FC } from "react"
import { useDevMode } from "app/contexts/DevModeContext"

/**
 * 開発モードのON/OFFを切り替えるフローティングボタン
 * - 画面右下に固定表示
 * - NODE_ENV === "development" の場合のみ表示
 * - クリックで開発UIの表示/非表示を切り替え
 */
export const DevModeToggle: FC = () => {
  const { isDevUIVisible, toggleDevUI } = useDevMode()

  // 本番環境では表示しない
  if (process.env.NODE_ENV !== "development") {
    return null
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 80,
        right: 16,
        zIndex: 9999,
      }}
    >
      <Tooltip
        title={isDevUIVisible ? "開発UIを非表示" : "開発UIを表示"}
        placement="left"
      >
        <IconButton
          onClick={toggleDevUI}
          sx={{
            width: 48,
            height: 48,
            backgroundColor: isDevUIVisible ? "warning.main" : "grey.400",
            color: "white",
            boxShadow: 3,
            "&:hover": {
              backgroundColor: isDevUIVisible ? "warning.dark" : "grey.600",
            },
            transition: "background-color 0.2s",
          }}
        >
          <span style={{ fontSize: "1.5rem" }}>🛠</span>
        </IconButton>
      </Tooltip>
    </Box>
  )
}
